"use strict";

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _freeze = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/freeze"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactUiTheming = require("@concur/react-ui-theming");
var _Icon = _interopRequireDefault(require("../Icon/Icon"));
var _IconButton = _interopRequireDefault(require("../IconButton/IconButton"));
var _StyleConfig = require("../utils/StyleConfig");
var _MessageStripConcur_android = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./MessageStrip-concur_android.css") : void 0);
var _MessageStripConcur_default = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./MessageStrip-concur_default.css") : void 0);
var _MessageStripConcur_gateway = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./MessageStrip-concur_gateway.css") : void 0);
var _MessageStripConcur_ios = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./MessageStrip-concur_ios.css") : void 0);
var _MessageStripSap_fiori_3_dark = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./MessageStrip-sap_fiori_3_dark.css") : void 0);
var _MessageStripSap_fiori_3_hcb = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./MessageStrip-sap_fiori_3_hcb.css") : void 0);
var _MessageStripSap_fiori_3_hcw = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./MessageStrip-sap_fiori_3_hcw.css") : void 0);
var _MessageStripSap_fiori_ = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./MessageStrip-sap_fiori_3.css") : void 0);
var _MessageStripSap_horizon_dark = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./MessageStrip-sap_horizon_dark.css") : void 0);
var _MessageStripSap_horizon_hcb = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./MessageStrip-sap_horizon_hcb.css") : void 0);
var _MessageStripSap_horizon_hcw = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./MessageStrip-sap_horizon_hcw.css") : void 0);
var _MessageStripSap_horizon = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./MessageStrip-sap_horizon.css") : void 0);
var _excluded = ["buttonProps", "className", "classNameMap", "dismissible", "iconProps", "message", "messageProps", "type", "typeLabel"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var styles = {
  concur_android: _MessageStripConcur_android.default,
  concur_default: _MessageStripConcur_default.default,
  concur_gateway: _MessageStripConcur_gateway.default,
  concur_ios: _MessageStripConcur_ios.default,
  sap_fiori_3_dark: _MessageStripSap_fiori_3_dark.default,
  sap_fiori_3_hcb: _MessageStripSap_fiori_3_hcb.default,
  sap_fiori_3_hcw: _MessageStripSap_fiori_3_hcw.default,
  sap_fiori_3: _MessageStripSap_fiori_.default,
  sap_horizon_dark: _MessageStripSap_horizon_dark.default,
  sap_horizon_hcb: _MessageStripSap_horizon_hcb.default,
  sap_horizon_hcw: _MessageStripSap_horizon_hcw.default,
  sap_horizon: _MessageStripSap_horizon.default
};
(0, _freeze.default)(styles);
var CSS_BLOCK = 'sapcnqr-messagestrip';

/**
 * The **MessageStrip** component displays state-related messages to the user.
 * It is intended to be part of the page layout and is more permanent than an
 * overlay (_e.g._ **MessageBox**, **Popover**).
 *
 * See the [Patterns/Message Handling](./?path=/docs/patterns-message-handling--docs) page
 * for more detailed information on selecting the appropriate messaging component.
 */

var MessageStrip = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var _classnames;
  var buttonProps = props.buttonProps,
    className = props.className,
    classNameMap = props.classNameMap,
    dismissible = props.dismissible,
    iconProps = props.iconProps,
    message = props.message,
    messageProps = props.messageProps,
    type = props.type,
    typeLabel = props.typeLabel,
    otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var classnames = _bind.default.bind(classNameMap);
  var classes = classnames(CSS_BLOCK, className, (_classnames = {}, (0, _defineProperty2.default)(_classnames, "".concat(CSS_BLOCK, "--").concat(type), type), (0, _defineProperty2.default)(_classnames, "".concat(CSS_BLOCK, "--dismiss"), dismissible), _classnames));
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, otherProps, {
    className: classes,
    "data-hcm": "bordered",
    ref: ref
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: classnames("".concat(CSS_BLOCK, "__screen-reader-only"))
  }, typeLabel), /*#__PURE__*/_react.default.createElement(_Icon.default, (0, _extends2.default)({}, iconProps, {
    ariaHidden: true,
    className: classnames("".concat(CSS_BLOCK, "__icon"), iconProps === null || iconProps === void 0 ? void 0 : iconProps.className),
    iconName: "messaging-".concat(type),
    size: "sm"
  })), /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, messageProps, {
    className: classnames("".concat(CSS_BLOCK, "__message"), messageProps === null || messageProps === void 0 ? void 0 : messageProps.className)
  }), message), dismissible && /*#__PURE__*/_react.default.createElement(_IconButton.default, (0, _extends2.default)({
    ariaLabel: dismissible.dismissLabel
  }, buttonProps, {
    className: classnames("".concat(CSS_BLOCK, "__dismiss"), buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.className),
    "data-test": "closeButton",
    iconName: "close",
    iconProps: _objectSpread({
      forceSize: 'xs-plus'
    }, buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.iconProps),
    muted: true,
    onClick: dismissible.onDismiss,
    tooltipDelay: -1
  })));
});
MessageStrip.displayName = 'MessageStrip';
MessageStrip.propTypes = {
  /** MessageStrip type (state). Options are `'success'`, `'info'`, `'warning'`, `'error'`. */
  type: _propTypes.default.oneOf(_StyleConfig.STATEFUL_MESSAGE_TYPES).isRequired,
  /** Localized string to describe the state of the **MessageStrip**.
   * Use `CoreUIComponents.information`, `CoreUIComponents.error`, `CoreUIComponents.warning`,
   * or `CoreUIComponents.success`. */
  typeLabel: _propTypes.default.string.isRequired,
  /** The message to display.  The prop type is node to permit text styling and links.
   * Do not pass in complex components. */
  message: _propTypes.default.node.isRequired,
  /** Additional props to be spread to the **Button** component. */
  buttonProps: _propTypes.default.object,
  /** Custom classes to be added to the outer `<div>` tag. */
  className: _propTypes.default.string,
  /** Include in order to add dismissible functionality. */
  dismissible: _propTypes.default.shape({
    /** Localized assistive text for the dismiss button. */
    dismissLabel: _propTypes.default.string.isRequired,
    /** Callback function fired when dismiss button is clicked.
     * @param {SyntheticEvent} event - React's original SyntheticEvent. See https://reactjs.org/docs/events.html. */
    onDismiss: _propTypes.default.func.isRequired
  }),
  /** Additional props to be spread to the **Icon** component. */
  iconProps: _propTypes.default.object,
  /** Additional props to be spread to the message `<div>` element. */
  messageProps: _propTypes.default.object
};
var _default = (0, _reactUiTheming.withThemeStyles)(styles)(MessageStrip);
exports.default = _default;